module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_ring-08db55d93bc9cf448cc5874c4ddd9b97.png";